/* global axios */
import ApiClient from './ApiClient';

class SearchAPI extends ApiClient {
  constructor() {
    super('search', { accountScoped: true });
  }

  get({ q, signal }) {
    return axios.get(this.url, {
      signal,
      params: {
        q,
      },
    });
  }

  senders({ q, id, signal } = {}) {
    return axios.get(`${this.url}/senders`, { params: { q, id }, signal });
  }

  contacts({ q, page = 1, since, until, signal }) {
    return axios.get(`${this.url}/contacts`, {
      signal,
      params: {
        q,
        page: page,
        since,
        until,
      },
    });
  }

  conversations({ q, page = 1, since, until, signal }) {
    return axios.get(`${this.url}/conversations`, {
      signal,
      params: {
        q,
        page: page,
        since,
        until,
      },
    });
  }

  messages({ q, page = 1, since, until, from, inboxId, signal }) {
    return axios.get(`${this.url}/messages`, {
      signal,
      params: {
        q,
        page: page,
        since,
        until,
        from,
        inbox_id: inboxId,
      },
    });
  }

  articles({ q, page = 1, since, until, signal }) {
    return axios.get(`${this.url}/articles`, {
      signal,
      params: {
        q,
        page: page,
        since,
        until,
      },
    });
  }
}

export default new SearchAPI();
